<template>
  <div>
    <div v-if="!ocultarLista && !soloLectura" class="d-flex justify-content-end mb-3">
      <button type="button" class="btn btn-sm btn-light-danger" @click.prevent="abrir(null)">
        <i class="fa fa-exclamation-triangle mr-1"></i> Registrar incidencia
      </button>
    </div>

    <div v-if="!ocultarLista && incidencias.length" class="table-responsive">
      <table class="table table-head-custom table-vertical-center table-head-bg table-hover mb-0">
        <thead>
          <tr>
            <th>Fecha y hora</th>
            <th>Tipo</th>
            <th>Descripción</th>
            <th>Evidencia</th>
            <th style="width: 44px;"></th>
            <th v-if="!soloLectura">Opciones</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="i in incidencias" :key="i.localVotacionFichaIncidenteId">
            <td>
              {{ i.horaEvento | time }}<br />
              <small class="text-muted">{{ i.horaEvento | date }}</small>
            </td>
            <td>
              {{ i.tipoIncidente }}<br />
              <small class="text-muted">{{ i.subtipoIncidente }}</small>
            </td>
            <td>{{ i.descripcion }}</td>
            <td>
              <div v-if="imagenesDe(i).length" class="d-flex flex-wrap">
                <a v-for="img in imagenesDe(i)" :key="img.procesoElectoralMultimediaImagenId || img.rutaArchivo"
                   :href="urlFoto(img.rutaArchivo)" target="_blank"
                   class="ficha-incidencia-thumb-tabla mr-1 mb-1">
                  <img :src="urlFoto(img.rutaArchivoThumb || img.rutaArchivo)" alt="Evidencia" />
                </a>
              </div>
              <span v-else class="text-muted">-</span>
            </td>
            <td class="text-center">
              <i v-if="i.ubicacion"
                 class="fa fa-map-marker-alt text-muted"
                 v-b-tooltip.hover.v-dark
                 :title="i.ubicacion"></i>
            </td>
            <td v-if="!soloLectura">
              <b-dropdown right>
                <template #button-content>
                  <i class="fas fa-ellipsis-v"></i>
                </template>
                <b-dropdown-item href="#" @click.prevent="abrir(i)">
                  <span class="navi-icon"><i class="fa fa-pencil-alt text-dark"></i> Editar</span>
                </b-dropdown-item>
                <b-dropdown-item href="#" @click.prevent="eliminar(i)">
                  <span class="navi-icon"><i class="fa fa-trash text-dark"></i> Eliminar</span>
                </b-dropdown-item>
              </b-dropdown>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <b-modal :id="idModal" size="lg" title="Registro de incidencia" hide-footer>
      <div class="form-group mb-4">
        <div class="btn-group d-flex" role="group">
          <button type="button" class="btn flex-grow-1"
                  :class="edicion.turno === 1 ? 'btn-primary' : 'btn-outline-primary'"
                  :disabled="soloLectura"
                  @click.prevent="edicion.turno = 1">Turno 1</button>
          <button type="button" class="btn flex-grow-1"
                  :class="edicion.turno === 2 ? 'btn-primary' : 'btn-outline-primary'"
                  :disabled="soloLectura"
                  @click.prevent="edicion.turno = 2">Turno 2</button>
        </div>
      </div>

      <div class="form-row">
        <div class="form-group col-md-6 mb-4">
          <label>Fecha</label>
          <input type="date" class="form-control" :value="edicion.fecha" disabled />
        </div>
        <div class="form-group col-md-6 mb-4">
          <label>Hora del hecho</label>
          <input type="time" class="form-control" v-model="edicion.hora" :disabled="soloLectura"
                 :class="{ 'is-invalid': errores.hora }" />
          <div v-if="errores.hora" class="invalid-feedback">{{ errores.hora }}</div>
        </div>
      </div>

      <div class="form-group mb-4">
        <label>Tipo de incidencia</label>
        <select class="form-control" v-model="edicion.tipoIncidenteParamId" :disabled="soloLectura"
                :class="{ 'is-invalid': errores.tipo }"
                @change="onCambioTipo">
          <option :value="null">Seleccione...</option>
          <option v-for="t in tipos" :key="t.parametroId" :value="t.parametroId">{{ t.descripcion }}</option>
        </select>
        <div v-if="errores.tipo" class="invalid-feedback d-block">{{ errores.tipo }}</div>
        <div v-if="ayudaTipo" class="alert alert-custom alert-light d-block py-3" style="border-left: 3px solid rgb(204, 204, 204);
          border-top-left-radius: 0px;
          border-top-right-radius: 0px;
          padding-left: 12px;">
          <div class="alert-text">{{ ayudaTipo }}</div>
        </div>
      </div>

      <div v-if="edicion.tipoIncidenteParamId" class="form-group mb-4">
        <label>Subtipo</label>
        <select class="form-control" v-model="edicion.subtipoIncidenteParamId" :disabled="soloLectura"
                :class="{ 'is-invalid': errores.subtipo }">
          <option :value="null">Seleccione...</option>
          <option v-for="s in subtipos" :key="s.parametroId" :value="s.parametroId">{{ s.descripcion }}</option>
        </select>
        <div v-if="errores.subtipo" class="invalid-feedback d-block">{{ errores.subtipo }}</div>
      </div>

      <div class="form-group mb-4">
        <label>Ubicación</label>
        <input type="text" class="form-control" v-model="edicion.ubicacion" maxlength="500"
               :disabled="soloLectura"
               :class="{ 'is-invalid': errores.ubicacion }"
               placeholder="Ej.: ingreso principal, patio, exterior, mesa 032145, segundo piso, puerta norte" />
        <div v-if="errores.ubicacion" class="invalid-feedback">{{ errores.ubicacion }}</div>
      </div>

      <div class="form-group mb-4">
        <label>Descripción</label>
        <textarea class="form-control" rows="4" v-model="edicion.descripcion" :disabled="soloLectura"
                  :class="{ 'is-invalid': errores.descripcion }"
                  placeholder="Describa únicamente hechos: qué ocurrió, quiénes intervinieron y en qué momento."></textarea>
        <div v-if="errores.descripcion" class="invalid-feedback">{{ errores.descripcion }}</div>
      </div>

      <div class="form-group mb-0">
        <label>Evidencia (fotografías)</label>
        <div v-if="imagenesExistentes.length" class="d-flex flex-wrap mb-3">
          <div v-for="img in imagenesExistentes" :key="img.procesoElectoralMultimediaImagenId || img.rutaArchivo"
               class="ficha-incidencia-thumb mr-3 mb-3">
            <a :href="urlFoto(img.rutaArchivo)" target="_blank" class="ficha-incidencia-thumb__link">
              <img :src="urlFoto(img.rutaArchivoThumb || img.rutaArchivo)" alt="Evidencia" />
            </a>
            <button v-if="!soloLectura" type="button" class="ficha-incidencia-thumb__quitar"
                    title="Eliminar" @click.prevent="quitarImagen(img)">
              <i class="fa fa-trash"></i>
            </button>
          </div>
        </div>
        <file-pond
          v-if="!soloLectura"
          :key="pondKey"
          ref="pond"
          class="ficha-incidencia-pond"
          name="evidenciaIncidencia"
          :allow-multiple="true"
          :allow-revert="true"
          :instant-upload="false"
          accepted-file-types="image/jpeg, image/png, image/gif, image/jpg"
          label-idle="Arrastra fotografías o <u>haz clic aquí</u><br><i class='fa fa-image fa-2x'></i>"
        />
        <small class="text-muted d-block mt-1">Siempre que sea posible, adjunta evidencia del hecho.</small>
      </div>

      <div class="text-right mt-4">
        <button type="button" class="btn btn-secondary mr-2" @click="$bvModal.hide(idModal)">
          {{ soloLectura ? "Cerrar" : "Cancelar" }}
        </button>
        <button v-if="!soloLectura" type="button" class="btn btn-primary"
                :disabled="guardando" @click="guardar">Guardar</button>
      </div>
    </b-modal>
  </div>
</template>

<style>
.ficha-incidencia-thumb-tabla {
  display: inline-block;
  line-height: 0;
}
.ficha-incidencia-thumb-tabla img {
  height: 48px;
  width: 48px;
  object-fit: cover;
  border: 1px solid #e4e6ef;
  border-radius: 4px;
  background: #fff;
}

.ficha-incidencia-thumb {
  position: relative;
  display: inline-block;
  line-height: 0;
}
.ficha-incidencia-thumb__link {
  display: block;
}
.ficha-incidencia-thumb img {
  height: 140px;
  width: auto;
  max-width: 220px;
  object-fit: contain;
  background: #fff;
  border: 1px solid #e4e6ef;
  border-radius: 4px;
}
.ficha-incidencia-thumb__quitar {
  position: absolute;
  top: 6px;
  right: 6px;
  z-index: 2;
  width: 28px;
  height: 28px;
  padding: 0;
  border: 0;
  border-radius: 50%;
  background: #fff;
  color: #858585;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.2);
  cursor: pointer;
}
.ficha-incidencia-thumb__quitar:hover {
  color: #f64e60;
  background: #fff;
}
.ficha-incidencia-thumb__quitar i {
  color: inherit;
}

.ficha-incidencia-pond.filepond--wrapper {
  border: 2px dashed #b5b5c3;
  border-radius: 8px;
}
.ficha-incidencia-pond .filepond--root {
  margin-bottom: 0;
}
.ficha-incidencia-pond .filepond--credits {
  display: none;
}
.ficha-incidencia-pond .filepond--drop-label {
  font-size: 1.15rem;
}
.ficha-incidencia-pond .filepond--panel-root {
  background-color: #eefaff;
}
.ficha-incidencia-pond .filepond--label-action {
  font-size: inherit;
}
.ficha-incidencia-pond .filepond--file-info,
.ficha-incidencia-pond .filepond--file-status {
  font-size: 0.95rem;
}
</style>

<script>
import vueFilePond from "vue-filepond";
import "filepond/dist/filepond.min.css";
import "filepond-plugin-image-preview/dist/filepond-plugin-image-preview.min.css";
import FilePondPluginFileValidateType from "filepond-plugin-file-validate-type";
import FilePondPluginImagePreview from "filepond-plugin-image-preview";

const FilePond = vueFilePond(FilePondPluginFileValidateType, FilePondPluginImagePreview);
const EVENTO_INCIDENCIA = "erm-ficha-incidencia-actualizada";

/**
 * Registro de incidencias ERM 2026 (Lima y Provincia).
 * Catálogo plano TIPO_INCIDENTE: padres = tipo, hijos = subtipo.
 * Propiedades.ayuda del tipo se muestra al seleccionarlo.
 */
export default {
  name: "FichaIncidencias",
  components: { FilePond },
  props: {
    localVotacionMesaProcesoElectoralId: { type: [Number, String], default: null },
    mesaVotacionId: { type: [Number, String], required: true },
    procesoElectoralId: { type: [Number, String], required: true },
    turno: { type: Number, required: true },
    soloLectura: { type: Boolean, default: false },
    ocultarLista: { type: Boolean, default: false },
    instancia: { type: String, default: "" },
  },
  data() {
    return {
      incidencias: [],
      parametros: [],
      guardando: false,
      pondKey: 0,
      imagenesExistentes: [],
      errores: {},
      edicion: this.nuevo(),
    };
  },
  computed: {
    idModal() {
      return this.instancia
        ? "mdl-incidencia-erm-" + this.instancia
        : "mdl-incidencia-erm-t" + this.turno;
    },
    tipos() {
      return this.parametros.filter((p) => p.parametroPadreId == null);
    },
    subtipos() {
      const tipoId = this.edicion.tipoIncidenteParamId;
      if (!tipoId) return [];
      return this.parametros.filter((p) => Number(p.parametroPadreId) === Number(tipoId));
    },
    ayudaTipo() {
      const tipo = this.tipos.find((t) => Number(t.parametroId) === Number(this.edicion.tipoIncidenteParamId));
      if (!tipo || !tipo.propiedades) return "";
      try {
        const p = typeof tipo.propiedades === "string" ? JSON.parse(tipo.propiedades) : tipo.propiedades;
        return (p && p.ayuda) || "";
      } catch (e) {
        return "";
      }
    },
  },
  mounted() {
    this.cargarParametros();
    if (!this.ocultarLista) this.listar();
    this.$root.$on(EVENTO_INCIDENCIA, this.onIncidenciaExterna);
  },
  beforeDestroy() {
    this.$root.$off(EVENTO_INCIDENCIA, this.onIncidenciaExterna);
  },
  methods: {
    turnoValido(valor) {
      const n = Number(valor);
      return n === 2 ? 2 : 1;
    },
    pad(n) {
      return String(n).padStart(2, "0");
    },
    ahoraLocal() {
      const d = new Date();
      return {
        fecha: d.getFullYear() + "-" + this.pad(d.getMonth() + 1) + "-" + this.pad(d.getDate()),
        hora: this.pad(d.getHours()) + ":" + this.pad(d.getMinutes()),
      };
    },
    partirFechaHora(valor) {
      const ahora = this.ahoraLocal();
      if (!valor) return ahora;
      const texto = String(valor);
      return {
        fecha: texto.substring(0, 10) || ahora.fecha,
        hora: texto.substring(11, 16) || ahora.hora,
      };
    },
    combinarFechaHora() {
      if (!this.edicion.fecha || !this.edicion.hora) return null;
      return this.edicion.fecha + "T" + this.edicion.hora;
    },
    nuevo() {
      const ahora = this.ahoraLocal();
      return {
        localVotacionFichaIncidenteId: 0,
        fecha: ahora.fecha,
        hora: ahora.hora,
        tipoIncidenteParamId: null,
        subtipoIncidenteParamId: null,
        ubicacion: "",
        descripcion: "",
        autoridadIntervencion: "",
        turno: this.turnoValido(this.turno),
      };
    },
    identificacion(turno) {
      return {
        localVotacionMesaProcesoElectoralId: this.localVotacionMesaProcesoElectoralId,
        mesaVotacionId: this.mesaVotacionId,
        procesoElectoralId: this.procesoElectoralId,
        turno: this.turnoValido(turno),
      };
    },
    imagenesDe(incidencia) {
      return incidencia && incidencia.imagenes ? incidencia.imagenes : [];
    },
    urlFoto(ruta) {
      return this.apiResource(ruta);
    },
    onCambioTipo() {
      this.edicion.subtipoIncidenteParamId = null;
      if (this.errores.tipo) this.$delete(this.errores, "tipo");
      if (this.errores.subtipo) this.$delete(this.errores, "subtipo");
    },
    cargarParametros() {
      this.$http
        .get(this.apiRoute("Parameter", "ListParametros"), { params: { Code: "TIPO_INCIDENTE" } })
        .then(function (response) {
          this.parametros = response.body.data || [];
        });
    },
    onIncidenciaExterna() {
      if (!this.ocultarLista) this.listar();
    },
    listar() {
      this.$http
        .post(this.apiRoute("Sheet", "ListFichaMesaIncidentes"), this.identificacion(this.turno))
        .then(function (response) {
          if (this.procesarRespuestaErrorDefecto(response)) return;
          this.incidencias = response.body.data || [];
        }, this.mostrarMensajeExcepcionVueResource);
    },
    abrir(incidencia) {
      this.pondKey += 1;
      this.errores = {};
      this.imagenesExistentes = this.imagenesDe(incidencia);
      if (incidencia) {
        const partes = this.partirFechaHora(incidencia.horaEvento);
        this.edicion = {
          localVotacionFichaIncidenteId: incidencia.localVotacionFichaIncidenteId,
          fecha: partes.fecha,
          hora: partes.hora,
          tipoIncidenteParamId: incidencia.tipoIncidenteParamId,
          subtipoIncidenteParamId: incidencia.subtipoIncidenteParamId || null,
          ubicacion: incidencia.ubicacion || "",
          descripcion: incidencia.descripcion,
          autoridadIntervencion: incidencia.autoridadIntervencion,
          turno: this.turnoValido(incidencia.turno || this.turno),
        };
      } else {
        this.edicion = this.nuevo();
      }
      this.$bvModal.show(this.idModal);
    },
    archivosPond() {
      if (!this.$refs.pond || typeof this.$refs.pond.getFiles !== "function") return [];
      return this.$refs.pond.getFiles() || [];
    },
    formDataBase(turno) {
      const fd = new FormData();
      const identificacion = this.identificacion(turno);
      Object.keys(identificacion).forEach((campo) => {
        if (identificacion[campo] === null || identificacion[campo] === undefined) return;
        fd.append(campo.charAt(0).toUpperCase() + campo.slice(1), identificacion[campo]);
      });
      return fd;
    },
    validar() {
      const errores = {};
      if (!this.edicion.hora) errores.hora = "Indique la hora del hecho.";
      if (!this.edicion.tipoIncidenteParamId) errores.tipo = "Seleccione el tipo de incidencia.";
      if (this.edicion.tipoIncidenteParamId && !this.edicion.subtipoIncidenteParamId)
        errores.subtipo = "Seleccione el subtipo.";
      if (!String(this.edicion.ubicacion || "").trim()) errores.ubicacion = "Indique la ubicación.";
      if (!String(this.edicion.descripcion || "").trim()) errores.descripcion = "Describa el hecho.";
      this.errores = errores;
      return Object.keys(errores).length === 0;
    },
    guardar() {
      if (!this.validar()) {
        const primero = Object.values(this.errores)[0];
        this.sweetAlert(primero || "Hay campos incompletos. Revise los datos ingresados.");
        return;
      }

      this.guardando = true;
      const fd = this.formDataBase(this.edicion.turno);
      fd.append("LocalVotacionFichaIncidenteId", this.edicion.localVotacionFichaIncidenteId || 0);
      const horaEvento = this.combinarFechaHora();
      if (horaEvento) fd.append("HoraEvento", horaEvento);
      fd.append("TipoIncidenteParamId", this.edicion.tipoIncidenteParamId);
      fd.append("SubtipoIncidenteParamId", this.edicion.subtipoIncidenteParamId);
      fd.append("Ubicacion", this.edicion.ubicacion || "");
      fd.append("Descripcion", this.edicion.descripcion || "");
      fd.append("AutoridadIntervencion", this.edicion.autoridadIntervencion || "");
      this.archivosPond().forEach((item) => {
        if (item && item.file) fd.append("Imagenes", item.file);
      });

      this.$http
        .post(this.apiRoute("Sheet", "AddEditFichaMesaIncidente"), fd)
        .then((response) => {
          this.guardando = false;
          if (this.procesarRespuestaErrorDefecto(response)) return;
          this.$bvModal.hide(this.idModal);
          this.$root.$emit(EVENTO_INCIDENCIA);
          this.$bvToast.toast(response.body.message || "Incidencia registrada.", {
            title: "Incidencia",
            autoHideDelay: 5000,
            variant: "success",
            solid: true,
          });
        }, (error) => {
          this.guardando = false;
          this.mostrarMensajeExcepcionVueResource(error);
        });
    },
    quitarImagen(img) {
      if (!this.edicion.localVotacionFichaIncidenteId) return;
      this.$bvModal
        .msgBoxConfirm("¿Eliminar esta evidencia?", {
          title: "Confirmar",
          okTitle: "Eliminar",
          cancelTitle: "Cancelar",
          okVariant: "danger",
          centered: true,
        })
        .then((confirmado) => {
          if (!confirmado) return;
          const fd = this.formDataBase(this.edicion.turno);
          fd.append("LocalVotacionFichaIncidenteId", this.edicion.localVotacionFichaIncidenteId);
          fd.append("RutaEliminar", img.rutaArchivo || img.rutaArchivoThumb);
          this.$http
            .post(this.apiRoute("Sheet", "AddEditFichaMesaIncidente"), fd)
            .then((response) => {
              if (this.procesarRespuestaErrorDefecto(response)) return;
              const ruta = img.rutaArchivo;
              this.imagenesExistentes = this.imagenesExistentes.filter((x) => x.rutaArchivo !== ruta);
              this.$root.$emit(EVENTO_INCIDENCIA);
            }, this.mostrarMensajeExcepcionVueResource);
        });
    },
    eliminar(incidencia) {
      this.$bvModal
        .msgBoxConfirm("¿Eliminar esta incidencia?", { okTitle: "Eliminar", cancelTitle: "Cancelar" })
        .then((confirmado) => {
          if (!confirmado) return;
          const fd = this.formDataBase(incidencia.turno || this.turno);
          fd.append("LocalVotacionFichaIncidenteId", incidencia.localVotacionFichaIncidenteId);
          fd.append("TipoIncidenteParamId", incidencia.tipoIncidenteParamId);
          fd.append("EsEliminado", true);
          this.$http.post(this.apiRoute("Sheet", "AddEditFichaMesaIncidente"), fd)
            .then((response) => {
              if (this.procesarRespuestaErrorDefecto(response)) return;
              this.$root.$emit(EVENTO_INCIDENCIA);
            }, this.mostrarMensajeExcepcionVueResource);
        });
    },
  },
};
</script>
